<div class="theme-wrapper" [class.dark-theme]="is_dark">
  <core-main-nav (theme_toggle)="is_dark = $event">
    <button mat-mini-fab color="primary" aria-label="Open the side nav" (click)="sidenav.toggle()" nav-toggle>
      <mat-icon>menu</mat-icon>
    </button>
    @if (!currentUser) {
      <button mat-raised-button color="accent" aria-label="Sign in" routerLink="/portal" sign-in>
        <mat-icon>account_circle</mat-icon> Sign in
      </button>
    }
    @if (currentUser) {
      <button (click)="showAccountDetails = !showAccountDetails" mat-mini-fab
        aria-label="My account" account>
        {{getFirstLetterOfName(currentUser)}}
      </button>
    }
  </core-main-nav>
  <mat-sidenav-container autosize class="app-container">
    <mat-sidenav [fixedInViewport]="true" [fixedTopGap]="fixedTopGap" #sidenav class="app-sidenav" mode="side">
      <core-side-nav></core-side-nav>
    </mat-sidenav>
    <mat-sidenav-content [style]="style" class="me-2">
      @if (currentUser && showAccountDetails) {
        <core-account-details (autoClose)="autoCloseAccountDetails()"
        [user]="currentUser" [roles]="currentRoles"></core-account-details>
      }
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>